import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import SchemaOrg from '@/components/base/SchemaOrg';
import VideoCard from '@/components/base/VideoCard';
import CategoryTabs from '@/components/base/CategoryTabs';
import { categories, videos } from '@/mocks/videos';

const categoryNameMap: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
};

export default function Home() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 8);
  const newVideos = videos.filter((v) => v.isNew).slice(0, 8);
  const allVideos = videos.slice(0, 12);

  return (
    <>
      <SEOHead
        title="51视频 | 香蕉视频·红桃视频·91视频影视大全 | 最新电影电视剧免费在线观看高清不卡顿不缓冲"
        description="51视频聚合香蕉视频、红桃视频、91视频等热门影视，提供最新电影、电视剧、综艺免费在线观看，高清不卡顿不缓冲。每日更新海量影视资源，追剧首选平台。"
        keywords="51视频,香蕉视频,红桃视频,91视频,影视大全,最新电影,电视剧,免费在线观看,高清,不卡顿,热门电视剧,综艺节目"
        canonicalUrl="https://51video.example.com/"
      />
      <SchemaOrg type="Organization" data={{
        name: '51视频',
        url: 'https://51video.example.com/',
        description: '聚合热门影视资源，提供最新电影、电视剧、综艺免费在线观看',
        sameAs: [],
      }} />
      <SchemaOrg type="WebSite" data={{
        name: '51视频',
        url: 'https://51video.example.com/',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://51video.example.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      }} />
      <SchemaOrg type="WebPage" data={{
        name: '51视频 - 首页',
        description: '51视频聚合香蕉视频、红桃视频、91视频等热门影视，提供最新电影、电视剧、综艺免费在线观看',
        url: 'https://51video.example.com/',
        isPartOf: { '@type': 'WebSite', name: '51视频', url: 'https://51video.example.com/' },
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          {/* Hero Section */}
          <section className="relative w-full h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden" aria-label="网站主视觉">
            <img
              src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20atmosphere%20with%20warm%20golden%20lighting%2C%20abstract%20film%20reel%20and%20light%20beams%2C%20luxurious%20dark%20velvet%20curtains%2C%20dramatic%20spotlight%20effect%2C%20elegant%20entertainment%20aesthetic%2C%20rich%20amber%20and%20deep%20red%20tones%2C%20cinematic%20composition&width=1920&height=700&seq=hero-bg-2026&orientation=landscape"
              alt="51视频 - 您的影视天堂"
              title="51视频 - 免费在线观影平台"
              className="absolute inset-0 w-full h-full object-cover object-top"
              width="1920"
              height="700"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
            <div className="relative z-10 w-full max-w-3xl mx-auto px-4 text-center">
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-4 leading-tight">
                海量影视，一网打尽
              </h2>
              <p className="text-base md:text-lg text-white/80 mb-8 max-w-xl mx-auto">
                聚合香蕉视频、红桃视频、91视频等热门影视资源，最新电影、电视剧、综艺高清在线，不卡顿不缓冲
              </p>
              <div className="flex items-center bg-white/15 backdrop-blur-sm rounded-full border border-white/20 overflow-hidden max-w-lg mx-auto">
                <i className="ri-search-line text-white/70 text-lg ml-5"></i>
                <input
                  type="text"
                  placeholder="搜索你想看的电影、电视剧、综艺..."
                  className="flex-1 bg-transparent text-white placeholder-white/50 px-4 py-3.5 text-sm outline-none"
                />
                <button className="bg-primary-500 hover:bg-primary-600 text-white px-6 py-3.5 text-sm font-medium rounded-full mr-1.5 transition-colors whitespace-nowrap cursor-pointer">
                  搜索
                </button>
              </div>
            </div>
          </section>

          {/* Category Navigation */}
          <section className="w-full px-4 md:px-6 py-8 md:py-10" aria-label="分类导航区域">
            <div className="max-w-7xl mx-auto">
              <CategoryTabs categories={categories} activeSlug="" />
            </div>
          </section>

          {/* Hot Videos */}
          <section className="w-full px-4 md:px-6 pb-10 md:pb-14" aria-label="热门推荐">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  <i className="ri-fire-line text-accent-500 mr-2"></i>
                  热门推荐
                </h3>
                <a href="/category/dianying" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                  查看更多 <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {hotVideos.map((video) => (
                  <VideoCard
                    key={video.id}
                    id={video.id}
                    title={video.title}
                    cover={video.cover}
                    rating={video.rating}
                    category={video.category}
                    updateInfo={video.updateInfo}
                    categoryName={categoryNameMap[video.category] || video.category}
                    isHot={video.isHot}
                    isNew={video.isNew}
                  />
                ))}
              </div>
            </div>
          </section>

          {/* New Videos */}
          <section className="w-full px-4 md:px-6 pb-10 md:pb-14" aria-label="最新上架">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  <i className="ri-sparkling-line text-primary-500 mr-2"></i>
                  最新上架
                </h3>
                <a href="/category/dianshiju" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
                  查看更多 <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                {newVideos.map((video) => (
                  <VideoCard
                    key={video.id}
                    id={video.id}
                    title={video.title}
                    cover={video.cover}
                    rating={video.rating}
                    category={video.category}
                    updateInfo={video.updateInfo}
                    categoryName={categoryNameMap[video.category] || video.category}
                    isHot={video.isHot}
                    isNew={video.isNew}
                  />
                ))}
              </div>
            </div>
          </section>

          {/* All Videos */}
          <section className="w-full px-4 md:px-6 pb-14 md:pb-20" aria-label="全部影视">
            <div className="max-w-7xl mx-auto">
              <div className="flex items-center justify-between mb-6">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  精选推荐
                </h3>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
                {allVideos.map((video) => (
                  <VideoCard
                    key={video.id}
                    id={video.id}
                    title={video.title}
                    cover={video.cover}
                    rating={video.rating}
                    category={video.category}
                    updateInfo={video.updateInfo}
                    categoryName={categoryNameMap[video.category] || video.category}
                    isHot={video.isHot}
                    isNew={video.isNew}
                  />
                ))}
              </div>
            </div>
          </section>

          {/* Feature Highlights */}
          <section className="w-full bg-background-100 px-4 md:px-6 py-14 md:py-20" aria-label="平台优势">
            <div className="max-w-7xl mx-auto">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 text-center mb-10">
                为什么选择 <span className="text-primary-500">51视频</span>？
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {[
                  { icon: 'ri-4k-line', title: '高清画质', desc: '支持4K超清画质，为您带来影院级观影体验' },
                  { icon: 'ri-speed-up-line', title: '极速播放', desc: '全球CDN加速，加载流畅不卡顿不缓冲' },
                  { icon: 'ri-global-line', title: '海量资源', desc: '聚合香蕉视频、红桃视频、91视频等热门平台' },
                  { icon: 'ri-smartphone-line', title: '多端适配', desc: '电脑、平板、手机多端同步，随时随地追剧' },
                ].map((feature) => (
                  <div key={feature.title} className="bg-background-50 rounded-lg p-6 text-center">
                    <div className="w-14 h-14 bg-accent-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className={`${feature.icon} text-accent-500 text-2xl`}></i>
                    </div>
                    <h4 className="font-heading text-base font-semibold text-foreground-900 mb-2">{feature.title}</h4>
                    <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}